// extracted by mini-css-extract-plugin
module.exports = {"Image":"AvatarImage_Image__9E2oI","Name":"AvatarImage_Name__jBxIG"};